// fetch client bank details
export const FETCH_CLIENT_BANK_ACCOUNT_REQUESTED = "FETCH_CLIENT_BANK_ACCOUNT_REQUESTED";
export const FETCH_CLIENT_BANK_ACCOUNT_SUCCESS = "FETCH_CLIENT_BANK_ACCOUNT_SUCCESS";
export const FETCH_CLIENT_BANK_ACCOUNT_FAIL = "FETCH_CLIENT_BANK_ACCOUNT_FAIL";

// add bank account
export const ADD_BANK_ACCOUNT_REQUESTED = "ADD_BANK_ACCOUNT_REQUESTED";
export const ADD_BANK_ACCOUNT_SUCCESS = "ADD_BANK_ACCOUNT_SUCCESS";
export const ADD_BANK_ACCOUNT_FAIL = "ADD_BANK_ACCOUNT_FAIL";
export const ADD_BANK_ACCOUNT_CLEAR = "ADD_BANK_ACCOUNT_CLEAR";

// delete bank account
export const DELETE_BANK_ACCOUNT_REQUESTED = "DELETE_BANK_ACCOUNT_REQUESTED";
export const DELETE_BANK_ACCOUNT_SUCCESS = "DELETE_BANK_ACCOUNT_SUCCESS";
export const DELETE_BANK_ACCOUNT_FAIL = "DELETE_BANK_ACCOUNT_FAIL";

// edit bank account
export const EDIT_BANK_ACCOUNT_REQUESTED = "EDIT_BANK_ACCOUNT_REQUESTED";
export const EDIT_BANK_ACCOUNT_SUCCESS = "EDIT_BANK_ACCOUNT_SUCCESS";
export const EDIT_BANK_ACCOUNT_FAIL = "EDIT_BANK_ACCOUNT_FAIL";
export const EDIT_BANK_ACCOUNT_CLEAR = "EDIT_BANK_ACCOUNT_CLEAR";